import React from 'react'
import { navigate } from 'gatsby'
import { Text } from 'theme-ui'
import { Button, Svg } from 'ui'
import ButtonArray from 'images/button-arrow.svg'
import useCreateOrManageAccountUri from 'utils/useCreateOrManageAccountUri'
import { useAppSelector } from 'store/hooks'
import useShouldRenderOnClient from 'utils/useShouldRenderOnClient'

export default function GetStartedButton({
  featuredProfile,
  dataTestId,
}: {
  featuredProfile?: string
  dataTestId?: string
}): React.ReactElement {
  const createOrManageAccountUri = useCreateOrManageAccountUri(featuredProfile)
  const sessionToken = useAppSelector(s => s.persistData.sessionToken)
  const shouldRenderOnClient = useShouldRenderOnClient()

  return (
    <Button
      data-testid={dataTestId}
      ariaLabel={sessionToken ? 'Go to Dashboard' : 'Get Started'}
      variant="primary"
      sx={{
        width: 'fit-content',
        height: 'fit-content',
        px: '2.4rem',
        py: '1.6rem',
        borderRadius: '45px',
        mb: ['2.4rem', undefined],
        border: 'none',
      }}
      onClick={() => navigate(createOrManageAccountUri)}
    >
      {shouldRenderOnClient && (
        <Text
          sx={{
            fontSize: ['1.8rem', '2.1rem'],
            fontWeight: 'bold',
            mr: '0.8rem',
          }}
        >
          {sessionToken ? 'Go to Dashboard' : 'Get Started'}
        </Text>
      )}
      <Svg
        svg={ButtonArray}
        descriptiveText={sessionToken ? 'Navigate to dashboard' : 'Begin setup process'}
      />
    </Button>
  )
}
